import { TenantSettings } from './tenant-settings.types';
import { urbanIndexTenantSettings } from './tenants/urban-index.settings';
import { tbdsCommonTenantSettings } from './tenants/tbds-common.settings';

const TENANT_SETTINGS_REGISTRY: Record<string, TenantSettings> = {
  'urban-index': urbanIndexTenantSettings,
  'tbds-common': tbdsCommonTenantSettings,
};

export function getTenantSettings(tenantKey: string): TenantSettings {
  const key = String(tenantKey || '').trim();
  const settings = TENANT_SETTINGS_REGISTRY[key];
  if (!settings) {
    throw new Error(`Missing tenant settings for key '${key}'`);
  }
  return settings;
}
